import { RECEIVE_TRADE_DOCUMENTS, RESET_TRADE_DOCUMENTS } from "../actionTypes";

const tradeDocuments = (state = { applications: [] }, action) => {
  switch(action.type) {
    case RECEIVE_TRADE_DOCUMENTS:
      return {
        applications: [...state.applications, ...action.payload.applications],
        totalPages: action.payload.total_pages,
        invoiceCount: action.payload.invoice_count,
        purchaseOrderCount: action.payload.purchase_order_count,
      };

    case RESET_TRADE_DOCUMENTS:
      return { applications: [] };
    default:
      return state;
  }
};

export default tradeDocuments;



// WEBPACK FOOTER //
// ./src/features/trade_documents/reducers/tradeDocumentsReducer.js